import {openConfirmDialog} from 'platform/components';

import {UpdateVehicleOnPlatformApiArg} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {useAdPlatformsVehicleUpdate} from './useAdPlatformsVehicleUpdate';

export function useAdPlatformsVehicleUpdateDialog() {
  const {hasPublishedAdvertisements, updateAds} = useAdPlatformsVehicleUpdate();

  async function update(
    vehicleId: string,
    platformCode?: UpdateVehicleOnPlatformApiArg['platformCode'],
    onClose?: () => void
  ): Promise<void | false> {
    const hasAdvertisements = await hasPublishedAdvertisements(vehicleId);

    if (!hasAdvertisements) {
      return false;
    }

    openConfirmDialog({
      isInLightbox: true,
      text: i18n.t('entity.vehicle.labels.infoChangedUpdateClassifiedsQuestion'),
      onConfirm: () => updateAds(vehicleId, platformCode),
      onCloseComplete: () => {
        if (onClose) {
          onClose();
        }
      },
    });
  }

  return [update];
}
